import AppName from "./application_name";
import TitleApplication from "./app_name";
import getUrlApi from "./geturlapi";

const checkUrlHost = window.__RUNTIME_CONFIG__.REACT_APP_BROWSER_HOST === true;
const baseUrl = `http://${
  checkUrlHost ? getUrlApi() : window.__RUNTIME_CONFIG__.REACT_APP_API_HOST
}:${window.__RUNTIME_CONFIG__.REACT_APP_API_PORT}`;
const urlHardware = `http://${
  checkUrlHost
    ? getUrlApi()
    : window.__RUNTIME_CONFIG__.REACT_APP_API_HOST_HARDWARE
}:${window.__RUNTIME_CONFIG__.REACT_APP_API_PORT_HARDWARE}`;
const baseUrlSocket = `ws://${
  checkUrlHost ? getUrlApi() : window.__RUNTIME_CONFIG__.REACT_APP_SOCKET_HOST
}:${window.__RUNTIME_CONFIG__.REACT_APP_SOCKET_PORT}`;
const cctvDevices = `ws://${
  checkUrlHost ? getUrlApi() : window.__RUNTIME_CONFIG__.REACT_APP_API_HOST
}:9253`;
const applicationStatus = window.__RUNTIME_CONFIG__.NODE_ENV;
const intervalMachine =
  window.__RUNTIME_CONFIG__.REACT_APP_INTERVAL_MACHINE ?? "5";
const intervalSensor =
  window.__RUNTIME_CONFIG__.REACT_APP_INTERVAL_SENSOR ?? "5";
const chartBackwardMinutes =
  window.__RUNTIME_CONFIG__.REACT_APP_CHART_BACKWARD ?? "10";
const chartForwardMinutes =
  window.__RUNTIME_CONFIG__.REACT_APP_CHART_FORWARD ?? "5";
const oilStation = window.__RUNTIME_CONFIG__.REACT_APP_OIL_STATION ?? "1";
const appName = AppName(applicationStatus);

export {
  baseUrl,
  urlHardware,
  cctvDevices,
  baseUrlSocket,
  applicationStatus,
  appName,
  intervalMachine,
  intervalSensor,
  chartForwardMinutes,
  chartBackwardMinutes,
  TitleApplication,
  oilStation,
};
